<ng-container *ngIf="{ costUnitState: costUnitState$ | async, sharedDataState: sharedDataState$ | async } as s">

    <div class="cost-unit-container mat-elevation-z8">
        <div class="table-header">
            <mat-form-field subscriptSizing="dynamic">
                <input matInput #filter (keyup)="applyFilter($event.target.value)" placeholder="Filter">
                <button mat-icon-button matSuffix aria-label="clear" *ngIf="filter.value" (click)="filter.value=''; applyFilter('');">
                    <mat-icon>close</mat-icon>
                </button>
            </mat-form-field>

            <button mat-mini-fab
                    color="primary"
                    matTooltip="{{ 'app.page.cost-unit.actions.add.label' | translate }}"
                    (click)="onCreate()">
                <mat-icon>add</mat-icon>
            </button>
        </div>
        <mat-progress-bar color="accent" [style.visibility]="(s.costUnitState.loading || s.sharedDataState.isLoading) ? 'visible' : 'hidden'" mode="indeterminate"></mat-progress-bar>
        <div class="table-container">
            <table mat-table [dataSource]="dataSource" matSort>

                <ng-container matColumnDef="name">
                    <th mat-header-cell *matHeaderCellDef mat-sort-header>{{ "app.model.cost-unit.name.label" | translate }}</th>
                    <td mat-cell *matCellDef="let element">
                        {{element.name}}
                    </td>
                </ng-container>

                <ng-container matColumnDef="articleNr">
                    <th mat-header-cell *matHeaderCellDef mat-sort-header arrowPosition="before">{{ "app.model.cost-unit.articleNr.label" | translate }}</th>
                    <td mat-cell *matCellDef="let element">
                        {{element.articleNr}}
                    </td>
                </ng-container>

                <ng-container matColumnDef="edit-button">
                    <th mat-header-cell *matHeaderCellDef></th>
                    <td mat-cell *matCellDef="let element" class="actions-column">
                        <button mat-icon-button
                                color="primary"
                                matTooltip="{{ 'app.page.cost-unit.actions.edit.label' | translate }}"
                                (click)="onEdit(element)">
                            <mat-icon>edit</mat-icon>
                        </button>
                        <button mat-icon-button
                                color="warn"
                                matTooltip="{{ 'app.page.cost-unit.actions.delete.label' | translate }}"
                                (click)="onDeleteCostUnit(element)">
                            <mat-icon>delete</mat-icon>
                        </button>
                    </td>
                </ng-container>
                <tr mat-header-row *matHeaderRowDef="s.costUnitState.columns; sticky: true"></tr>
                <tr mat-row *matRowDef="let row; columns: s.costUnitState.columns;"></tr>

            </table>
        </div>
        <mat-paginator showFirstLastButtons [pageSize]="20" [pageSizeOptions]="[20, 50]"></mat-paginator>
    </div>


</ng-container>
